<template>
  <div>
    <div class="card">
      <div class="card-header">
        Update Week
      </div>
      <div class="card-body">
        <div v-if="!weekUpdated">
          <p>The current week is {{currentWeek}}</p>
          <p>Which week would you like to move to? <CInput @input="weekInputChanged" /></p>
          <p><CButton :color="weekInputValid ? 'primary' : 'secondary'" @click="moveToNextWeek()">Update</CButton></p>
        </div>
        <div v-else class="card-body">
          <p>Week updated to {{Number(currentWeek) + 1}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateWeek',
  data() {
    return {
      weekInputValue: ""
    }
  },
  created() {
    this.$store.dispatch("loadCurrentWeek");
  },
  methods: {
    weekInputChanged: function(newValue, event) {
      this.weekInputValue = newValue;
    },
    moveToNextWeek: function() {
      if(this.weekInputValid) {
        this.$store.dispatch("saveWeek");
      } else {
        console.log("Week input value is not valid");
      }
    }
  },
  computed: {
    weekInputValid: function() {
      return Number(this.weekInputValue) == Number(this.currentWeek) + 1;
    },
    currentWeek: function() {
      return this.$store.state.updateWeek.currentWeek;
    },
    weekUpdated: function() {
      return this.$store.state.updateWeek.newWeekSet;
    }
  }
}
</script>
